export default "__VITE_ASSET__DoldZOaC__"